import React from "react";
import BlogUsuariosComprarPack from "../../components/blogs/BlogDetails/BlogUsuariosComprarPack";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import PageHeader from "../../components/team/PageHeader";

export default function HelpUserComoComprarUnPack() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        HeaderTitle="Como Comprar un Pack"
        PageTitle="Comprar un Pack"
        Parent="Ayuda"
      />
      <BlogUsuariosComprarPack />
      <Footer />
    </Layout>
  );
}
